var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-link',_vm._g(_vm._b({staticClass:"text-ellipsis link-filename",attrs:{"target":"_blank"},on:{"click":function($event){return _vm.downLoadFile(_vm.file)}}},'el-link',_vm.$attrs,false),_vm.$listeners),[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.file.fileName)+" ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }